import { computed, toValue } from "vue";
const useFadeTransition = (fade) => computed(() => {
  const NO_FADE_PROPS = {
    name: "",
    enterActiveClass: "",
    enterToClass: "",
    leaveActiveClass: "",
    leaveToClass: "showing",
    enterFromClass: "showing",
    leaveFromClass: ""
  };
  const FADE_PROPS = {
    ...NO_FADE_PROPS,
    enterActiveClass: "fade showing",
    leaveActiveClass: "fade showing"
  };
  return toValue(fade) ? FADE_PROPS : NO_FADE_PROPS;
});
export {
  useFadeTransition as u
};
//# sourceMappingURL=useTransitions-BJccF5e-.mjs.map
